var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 89,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.43 81.662h-7.303c.22 4.336.358 7.151.358 7.151l-57.396.024.372-7.176H3.026L0 67.843l9.54-6.877c.467-8.894.932-17.625 1.194-22.26.67-11.797 9.644-13.067 9.644-13.067s.71-4.206 1.562-11.787c2.037-18.111 27.909-19.028 30.094.603.422 3.796 1.354 10.29 1.354 10.29s8.356.646 9.247 12.443c.346 4.582.853 13.393 1.343 22.455l11.329 8.433-2.877 13.586zM52.071 57.917l-1.255 10.397-3.4-.137V26.298c0-20.34-20.682-19.027-20.682-.524v42.648l-3.179.271-2.082-9.837L5.644 70.314l1.621 7.631 25.978-.401 1.774-13.438 4.679-.18 1.921 13.489 26.692-.412 1.288-6.969-17.526-12.117zM30.86 31.515c-1.793-6.343 1.816-9.776 6.321-9.776 5.206 0 8.03 3.812 6.163 9.738l-12.484.038z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.6f915535831e1c27246c5bc76ade1055.svg";
export { ForwardRef as ReactComponent };